import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  anonymousUserTooltip: {
    id: 'bitkit.navigation.accountMenu.anonymousUserTooltip',
    description: 'Text for tooltip on the menu trigger for anonymous users',
    defaultMessage: 'Anonymous! Click to log in or sign up.',
  },

  loggedInUserTooltip: {
    id: 'bitkit.navigation.accountMenu.loggedInUserTooltip',
    description: 'Text for tooltip on the menu trigger for logged in users',
    defaultMessage: 'Your profile',
  },

  viewProfileLink: {
    id: 'bitkit.navigation.accountMenu.viewProfileLink',
    description: `Text for link to view user's profile`,
    defaultMessage: 'View profile',
  },

  manageAtlassianAccountLink: {
    id: 'bitkit.navigation.accountMenu.manageAtlassianAccountLink',
    description: `Text for link to manage user's Atlassian account`,
    defaultMessage: 'Manage Atlassian account',
  },

  accountHeader: {
    id: 'bitkit.navigation.accountMenu.accountHeader',
    description: 'Text for Account header',
    defaultMessage: 'Account',
  },

  integrationsLink: {
    id: 'bitkit.navigation.accountMenu.integrationsLink',
    description: 'Text for link to view available integrations',
    defaultMessage: 'App marketplace',
  },

  switchAccountLink: {
    id: 'bitkit.navigation.accountMenu.switchAccountLink',
    description: 'Text for link to switch account user is logged in to',
    defaultMessage: 'Switch account',
  },

  logOutLink: {
    id: 'bitkit.navigation.accountMenu.logOutLink',
    description: 'Text for link to log out',
    defaultMessage: 'Log out',
  },

  signUpLink: {
    id: 'bitkit.navigation.accountMenu.signUpLink',
    description: 'Text for link to sign up',
    defaultMessage: 'Sign up',
  },

  logInLink: {
    id: 'bitkit.navigation.accountMenu.logInLink',
    description: 'Text for link to log in',
    defaultMessage: 'Log in',
  },

  workspacesHeader: {
    id: 'bitkit.navigation.accountMenu.workspacesHeader',
    description: 'Text for workspaces header',
    defaultMessage: 'Recent workspaces',
  },

  viewAllWorkspacesLink: {
    id: 'bitkit.navigation.accountMenu.viewAllWorkspacesLink',
    description: 'Text for link to view all workspaces',
    defaultMessage: 'All workspaces',
  },

  newLabel: {
    id: 'bitkit.navigation.accountMenu.newFeatureLozenge',
    description: 'Text to show inside the lozenge alongside new feature',
    defaultMessage: 'New',
  },
});
